var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 10.8L15.75 10.275C14.775 9.675 14.775 8.25 15.75 7.65L16.65 7.125C17.4 6.675 17.625 5.775 17.175 5.1L16.425 3.825C15.975 3.075 15.075 2.85 14.4 3.3L13.5 3.825C12.525 4.425 11.25 3.675 11.25 2.55V1.5C11.25 0.675 10.575 0 9.75 0H8.25C7.425 0 6.75 0.675 6.75 1.5V2.475C6.75 3.6 5.47501 4.35 4.50001 3.75L3.60001 3.3C2.85001 2.85 1.95001 3.15 1.57501 3.825L0.825005 5.1C0.450005 5.85 0.675005 6.75 1.35001 7.2L2.25001 7.725C3.22501 8.25 3.22501 9.75 2.25001 10.275L1.35001 10.8C0.600005 11.25 0.375005 12.15 0.825005 12.825L1.57501 14.1C2.02501 14.85 2.92501 15.075 3.60001 14.625L4.50001 14.175C5.47501 13.575 6.75 14.325 6.75 15.45V16.5C6.75 17.325 7.425 18 8.25 18H9.75C10.575 18 11.25 17.325 11.25 16.5V15.525C11.25 14.4 12.525 13.65 13.5 14.25L14.4 14.775C15.15 15.225 16.05 14.925 16.425 14.25L17.175 12.975C17.55 12.15 17.325 11.25 16.65 10.8ZM9 12C7.35 12 6.00001 10.65 6.00001 9C6.00001 7.35 7.35 6 9 6C10.65 6 12 7.35 12 9C12 10.65 10.65 12 9 12Z",
    fill: "#C4BBFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.9e976294.svg";
export { ForwardRef as ReactComponent };